/**
 * DNA Spacer module
 *
 * Static or animated DNA sequence strand
 */

// Deps
import { createComponent, RendererContext } from "react-fela";
import { useContext } from "react";
import { fluid } from "~/styleguide/utils";

let animationName = "";

export default function DNASpacer({ block }) {
    const { is_animated } = block;
    const renderer = useContext(RendererContext);
    animationName = renderer.renderKeyframe(keyframes);

    return (
        <Container isAnimated={is_animated} className="module-dna-slider">
            <Strand orientation="top" />
            <Strand orientation="bottom" />
        </Container>
    );
}

const Container = createComponent(() => ({
    textAlign: "center"
}));

const Strand = createComponent(({ orientation }) => ({
    width: "100%",
    backgroundSize: "auto 100%",
    backgroundPosition: "0 0",
    animationName: `${animationName}`,
    animationDuration: "260s",
    animationTimingFunction: "linear",
    animationIterationCount: "infinite",
    backgroundRepeat: "repeat-x",
    extend: [
        fluid("height", { max: 20, min: 14 }),
        {
            condition: orientation === "top",
            style: {
                animationDirection: "normal",
                backgroundImage:
                    "url(" +
                    require("~/assets/image/dna-spacer-strand-top.png") +
                    ")"
            }
        },
        {
            condition: orientation === "bottom",
            style: {
                marginTop: 6,
                animationDirection: "reverse",
                backgroundImage:
                    "url(" +
                    require("~/assets/image/dna-spacer-strand-top.png") +
                    ")"
            }
        }
    ]
}));

const keyframes = () => ({
    from: { backgroundPosition: "-100% 0" },
    to: { backgroundPosition: "100% 0" }
});
